import { render, staticRenderFns } from "./SignatureIndicator.vue?vue&type=template&id=b3807cdc&"
import script from "./SignatureIndicator.vue?vue&type=script&lang=js&"
export * from "./SignatureIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports